module.exports = __webpack_public_path__ + "img/selected_icon.ce25713.png";